import {
  CircleHelp,
  CircleUserRound,
  //  Compass,
  FilePlus2,
  HomeIcon,
  PlusIcon,
  Inbox,
  LayoutGrid,
  LogOut,
  SquareCheckBig,
} from "lucide-react";
import { ROUTES } from "@/core/router/routes";
import { TFunction } from "i18next";
import { getDashboardLink } from "@/shared/utils/link";
import { IWorkspace } from "@/shared/services/interface/responses/IWorkspaceResponses";

export const navMainItems = (
  t: TFunction,
  unreadInboxCount?: number,
  isHideTitle: boolean = false
) => [
  // {
  //   title: t("dashboard"),
  //   url: getLink(ROUTES.Dashboard.Root),
  //   icon: LayoutDashboard,
  //   isActive: true
  // },
  {
    title: t("specification"),
    url: getDashboardLink(ROUTES.Dashboard.Specification.List),
    icon: FilePlus2,
    isActive: false,
  },
  {
    title: t("inbox:inbox"),
    url: getDashboardLink(ROUTES.Dashboard.Inbox.Root),
    icon: Inbox,
    isActive: false,
    badge: isHideTitle ? 0 : unreadInboxCount || 0,
    isHide: isHideTitle,
  },
  {
    title: t("supplier-responses"),
    url: getDashboardLink(ROUTES.Dashboard.Specification.SupplierResponsesAll),
    icon: SquareCheckBig,
    isActive: false,
  },
  // {
  //   title: t("product-discovery"),
  //   url: getDashboardLink(ROUTES.Dashboard.Specification.ProductDiscoverySingleCreate),
  //   icon: Compass,
  //   isActive: false
  // },
  // {
  //   title: t("product-comparison"),
  //   url: "#",
  //   icon: Box,
  //   isActive: false,
  //   items: [
  //     {
  //       title: t("product-comparison"),
  //       url: "#",
  //       items: [
  //         {
  //           icon: Box,
  //           title: t("product-comparison"),
  //           url: "#"
  //         }
  //       ]
  //     }
  //   ]
  // }
];
export const settingsNavItems = (
  t: TFunction,
  isHideTitle: boolean = false,
  logout?: () => void
) => [
  // {
  //   title: t("inbox:inbox"),
  //   url: getDashboardLink(ROUTES.Dashboard.Inbox.Root),
  //   icon: Inbox,
  //   badge: isHideTitle ? undefined : unreadInboxCount || 0,
  //   isHide: isHideTitle,
  // },
  // {
  //   title: t("settings"),
  //   url: getDashboardLink(ROUTES.Dashboard.Setting.Root),
  //   icon: Settings,
  //   isHide: isHideTitle,
  // },
  {
    title: t("help-and-support"),
    url: "#",
    icon: CircleHelp,
    isHide: isHideTitle,
  },
  {
    title: t("logout"),
    url: "#",
    icon: LogOut,
    isHide: isHideTitle,
    onClick: logout,
  },
];

export const settingLayoutNavItems = (
  t: TFunction,
  workspaces?: IWorkspace[]
) => [
  {
    title: t("setting:general"),
    url: "#",
    icon: HomeIcon,
    isActive: true,
    items: [
      {
        title: t("setting:members"),
        url: getDashboardLink(ROUTES.Dashboard.Setting.Members),
      },

      {
        title: t("setting:plans-and-billing"),
        url: getDashboardLink(ROUTES.Dashboard.Setting.PlansAndBillings),
      },
    ],
  },
  {
    title: t("setting:my-account"),
    url: "#",
    icon: CircleUserRound,
    isActive: true,
    items: [
      {
        title: t("setting:my-profile"),
        url: getDashboardLink(ROUTES.Dashboard.Setting.MyProfile),
      },
      {
        title: t("setting:company-info"),
        url: getDashboardLink(ROUTES.Dashboard.Setting.CompanyInfo),
      },
      {
        title: t("setting:integrations"),
        url: getDashboardLink(ROUTES.Dashboard.Setting.Integrations),
      },
      {
        title: t("setting:security-and-access"),
        url: getDashboardLink(ROUTES.Dashboard.Setting.SecurityAccess),
      },
    ],
  },
  {
    title: t("setting:my-workspaces"),
    url: "#",
    icon: LayoutGrid,
    isActive: true,
    items: [
      ...(workspaces?.map((workspace) => ({
        title: workspace.name,
        url: getDashboardLink(ROUTES.Dashboard.Setting.Workspace.MyWorkspaces),
        workspace: workspace,
        isWorkspace: true,
      })) || []),
      {
        title: t("setting:create-workspace"),
        url: getDashboardLink(ROUTES.Dashboard.Setting.Workspace.Create),
        beforeIcon: PlusIcon,
      },
    ],
  },
];
